/**
 * @module Product Details
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { ChannelSegment } from '@support/api/common/product.interface';
// import { CHANNELS, SETTINGS } from '@environment/settings';
import { HARDGOODS_CONSTANTS } from '@experience/shop/hardgoods/constants/browse-hardgoods.constants';
import { SHARED_BROWSE_CONSTANTS } from '@experience/shop/shared-browse/constants/shared-browse.constants';

export class ProductDetailsRequestModel {
  private productTypes: string[];

  private productSubTypes: string[];

  private billingType: string;

  private transactionTypes: string[];

  private postalCode: string;

  private storeId: string;

  private offerTypes: string[];

  private offerSubTypes: string[];

  private pageSize: string;

  private pageNumber: string;

  private customerId: string;

  private accountId: string;

  private isCertifiedPreOwned: boolean;

  public channelSegment: ChannelSegment;
  constructor(
    channel: string,
    type: string,
    billingType: string,
    storeId: string,
    zip: string,
    customerId?: string,
    accountId?: string,
    hasCPO?: boolean
  ) {
    this.setType(type);
    this.productSubTypes = ['Handset'];
    this.billingType = billingType;
    this.transactionTypes = ['ACTIVATION'];
    this.postalCode = zip;
    this.storeId = storeId;
    this.offerTypes = ['Base'];
    this.offerSubTypes = ['HardGood'];
    if (
      customerId !== SHARED_BROWSE_CONSTANTS.ANON &&
      customerId !== SHARED_BROWSE_CONSTANTS.EMPTY_STRING
    ) {
      this.customerId = customerId;
      this.accountId = accountId;
    }
    this.pageSize = '10';
    this.pageNumber = '1';
    this.channelSegment = {};
    this.channelSegment.salesChannelCode = HARDGOODS_CONSTANTS.SALES_CHANNEL_CODE_WEB;
    this.channelSegment.salesSubChannelCode = HARDGOODS_CONSTANTS.SALES_SUB_CHANNEL_CODE_WEB;
    this.channelSegment.subChannelCategory = HARDGOODS_CONSTANTS.SUB_CHANNEL_CATEGORY_WEB;
    // switch (SETTINGS.CHANNEL) {
    //   case CHANNELS.CARE:
    //     this.channelSegment.salesChannelCode = HARDGOODS_CONSTANTS.SALESCHANNELCODE_CARE;
    //     this.channelSegment.salesSubChannelCode = HARDGOODS_CONSTANTS.SALESSUBCHANNELCODE_CARE;
    //     this.channelSegment.subChannelCategory = HARDGOODS_CONSTANTS.SUBCHANNELCATEGORY;
    //     break;
    //   case CHANNELS.RETAIL:
    //     this.channelSegment.salesChannelCode = HARDGOODS_CONSTANTS.SALES_CHANNEL_CODE_RETAIL;
    //     this.channelSegment.salesSubChannelCode = HARDGOODS_CONSTANTS.SALES_SUB_CHANNEL_CODE_RETAIL;
    //     this.channelSegment.subChannelCategory = HARDGOODS_CONSTANTS.SUB_CHANNEL_CATEGORY_RETAIL;
    //     break;
    //   case CHANNELS.WEB:
    //     this.channelSegment.salesChannelCode = HARDGOODS_CONSTANTS.SALES_CHANNEL_CODE_WEB;
    //     this.channelSegment.salesSubChannelCode = HARDGOODS_CONSTANTS.SALES_SUB_CHANNEL_CODE_WEB;
    //     this.channelSegment.subChannelCategory = HARDGOODS_CONSTANTS.SUB_CHANNEL_CATEGORY_WEB;
    //     break;
    //   default:
    //     break;
    // }
    if (hasCPO) {
      this.isCertifiedPreOwned = hasCPO;
    }
  }

  private setType(type: string): void {
    this.productTypes = type ? [type] : ['Device'];
  }
}
